import { render, staticRenderFns } from "./DashboardMarketing.vue?vue&type=template&id=47596712"
import script from "./DashboardMarketing.vue?vue&type=script&lang=js"
export * from "./DashboardMarketing.vue?vue&type=script&lang=js"
import style0 from "./DashboardMarketing.vue?vue&type=style&index=0&id=47596712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports